export default (callback) => {
  if (document.readyState != 'loading') { return callback() }

  document.addEventListener('DOMContentLoaded', callback)
}